import { CardInterface } from '@modules/card/interfaces/card.interface';
import { CardModel } from '@modules/card/models/card.model';

import { SectionType } from '../enums/section-type.enum';

import { Section } from './section.model';

export interface StaggeredSectioInterface {
  headline?: string;
  anchor?: string;
  teasers: CardInterface[];
}

export class StaggeredSectionModel implements Section {
  public type = SectionType.STAGGERED;

  public teaserLarge: CardModel;
  public teasersMedium: CardModel[];
  public teasersSmall: CardModel[];
  public headline?: string;
  public anchor?: string;

  constructor(data: StaggeredSectioInterface) {
    this.headline = data.headline;
    this.anchor = data.anchor;
    const _teasers = data.teasers.map((item) => new CardModel(item));
    this.teaserLarge = _teasers[0];
    this.teasersMedium = [_teasers[1], _teasers[2], _teasers[3]];
    this.teasersSmall = [_teasers[4], _teasers[5], _teasers[6], _teasers[7]];
  }
}
